import { render, staticRenderFns } from "./detailGD.vue?vue&type=template&id=68fb5967&scoped=true"
import script from "./detailGD.vue?vue&type=script&lang=js"
export * from "./detailGD.vue?vue&type=script&lang=js"
import style0 from "./detailGD.vue?vue&type=style&index=0&id=68fb5967&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fb5967",
  null
  
)

export default component.exports